export async function recordEvent(event: string) {
  await fetch('https://api.cmitinternational.com.au/metrics', {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify({
      event,
    }),
  })
}
